import { Injectable } from '@angular/core';
import { BaseService } from '@core/service/base.service';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import {Observable, Subject} from 'rxjs/index';

export const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

@Injectable({
  providedIn: 'root'
})

export class SourceItemsService extends BaseService{
  private url = 'api/sourcing';
  private supplierUrl = 'api/supplier/get-dto';
  constructor(http: HttpClient) {
    super(http);
  }

  public sendData = new Subject<any>();
  getUrl(): string {
    return this.url;
  }

  //获取供应商联系人模块信息
  getSupContact(id):Observable<any> {
    let params = {
      supplierId:id,
      supModule:['SUP_CONTACT']
    };
    return this.http.get(this.supplierUrl,
      {
        headers: httpOptions.headers,
        params:params
      }
    ).pipe(
      tap(() => this.log('getSupContact')),
      catchError(this.handleError('getSupContact'))
    );
  }

  /**
   * 提交
   * @param object 招投标对象
   */
  submit(object: any): Observable<any> {
    const url = `${this.getUrl()}/submit`;
    return this.http.post<any>(url, object, httpOptions).pipe(
      tap((object: any) => this.log(`submit object =${object}`)),
      catchError(this.handleError<any>('submit')),
    );
  }

  /**
   * 发送开标密码
   * @param id 招投标id
   */
  sendBidOpeningPassword(id: number): Observable<any> {
    const url = `${this.getUrl()}/${id}/send-bid-opening-password`;
    return this.http.post<any>(url, {}, httpOptions).pipe(
      tap((object: any) => this.log(`sendBidOpeningPassword id =${id}`)),
      catchError(this.handleError<any>('sendBidOpeningPassword')),
    );
  }

  /**
   * 开标
   * @param id 招投标id
   * @param object 开标密码，如无需密码传空对象{}
   */
  bidOpening(id: number, object: any): Observable<any> {
    const url = `${this.getUrl()}/${id}/bid-opening`;
    return this.http.post<any>(url, object, httpOptions).pipe(
      tap((object: any) => this.log(`bidOpening id =${id}`)),
      catchError(this.handleError<any>('bidOpening')),
    );
  }

  /**
   * 获取招投标项目管理的提示信息
   */
  GetScoringTip(id:number,round:number):Observable<any> {
    const url = `${this.getUrl()}/${id}/sourcing-message/${round}`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`Get Sourcing Tip id=${id} ,round = ${round}`)),
      catchError(this.handleError<any>(`Get Sourcing Tip id=${id},round = ${round}`))
    );
  }


  /**
   *  複製項目
   */
  getAllCopy(id):Observable<any> {
    const url = `${this.getUrl()}/${id}/copy`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`getAllType`)),
      catchError(this.handleError<any>(`getAllType`))
    );
  }

  /**
   *  获取招投标项目
   */
  getSourcing(id):Observable<any> {
    const url = `${this.getUrl()}/${id}`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`getSourcing`)),
      catchError(this.handleError<any>(`getSourcing`))
    );
  }
  /**
   *  获取招投标项目
   */
  getSystemDefault(mainCode,typeCode):Observable<any> {
    const url = `${this.getUrl()}/getSystem-default`;
    return this.http.get<any>(url,{params: {'mainCode':mainCode,'typeCode':typeCode}}).pipe(
      tap(_ => this.log(`getSourcing`)),
      catchError(this.handleError<any>(`getSourcing`))
    );
  }

  toSourcingByIds(ids: any):Observable<any> {
    const url = `api/purRequisition/ids-tosourcing`;
    return this.http.put<any>(url, ids, httpOptions).pipe(
      tap((object: any) => this.log(`toSourcingByIds`)),
      catchError(this.handleError<any>('bidOpening')),
    );
  }

  /**
   * 提交
   * @param object 招投标对象
   */
  autoConfimrSupplier(object: any): Observable<any> {
    const url = `${this.getUrl()}/auto-confirm`;
    return this.http.post<any>(url, object, httpOptions).pipe(
      tap((object: any) => this.log(`submit object =${object}`)),
      catchError(this.handleError<any>('submit')),
    );
  }

  //保存基本信息
  updateBaseInfo(object:any):Observable<any> {
    return this.http.put<any>('api/sourcing-base-info', object, httpOptions).pipe(
      tap(_ => this.log(`updated object =${object}`)),
      catchError(
        this.handleError<any>('updateBaseInfo')
      )
    );
  }
  /**
   *  获取附件历史
   */
  getHisAttach(sourcingId,type):Observable<any> {
    const url = `${this.getUrl()}/his-attach`;
    return this.http.get<any>(url,{params: {'sourcingId':sourcingId,'type':type}}).pipe(
      tap(_ => this.log(`getSourcing`)),
      catchError(this.handleError<any>(`getSourcing`))
    );
  }

  getAllSourcingNo(params: HttpParams):Observable<any> {
    const url = `${this.getUrl()}/queryByCustom`;
    return this.http.get<any>(url,
      {
        headers: httpOptions.headers,
        observe: 'response',//完整数据返回，包括抬头
        params: params,
      },
      ).pipe(
      tap(_ => this.log(`getAllSourcingNo`)),
      catchError(this.handleError<any>(`getAllSourcingNo`))
    );
  }

  /**
   *  根据单号获取id
   */
  getIdByNum(num): Observable<any> {
    const url = `${this.getUrl()}/getId_byNum`;
    return this.http.get<any>(url, {params: {'num': num}}).pipe(
        tap(_ => this.log(`getSourcing`)),
        catchError(this.handleError<any>(`getSourcing`))
    );
  }

}
